import React from "react";

type Props = { data: number[] };

export default function StackedBar({ data }: Props) {
  const totalCount = data.reduce((acc, cur) => acc + cur, 0);
  const percentage = data.map((d) => (d / totalCount) * 100);

  return (
    <div className="min-h-[25px] rounded-[3px] flex text-white text-xs leading-4 w-full">
      {percentage[0] > 0 && (
        <div
          className="bg-[#00CDC1] flex items-center justify-center first:rounded-l-[3px] last:rounded-r-[3px]"
          style={{
            width: `${percentage[0]}%`,
          }}
        >
          {percentage[0].toFixed(0)}%
        </div>
      )}
      {percentage[1] > 0 && (
        <div
          className="bg-[#FF4343] flex items-center justify-center first:rounded-l-[3px] last:rounded-r-[3px]"
          style={{
            width: `${percentage[1]}%`,
          }}
        >
          {percentage[1].toFixed(0)}%
        </div>
      )}
      {percentage[2] > 0 && (
        <div
          className="bg-[#0496FF] flex items-center justify-center first:rounded-l-[3px] last:rounded-r-[3px]"
          style={{
            width: `${percentage[2]}%`,
          }}
        >
          {percentage[2].toFixed(0)}%
        </div>
      )}
      {percentage[3] > 0 && (
        <div
          className="bg-brand-neutral-20 flex items-center justify-center first:rounded-l-[3px] last:rounded-r-[3px]"
          style={{
            width: `${percentage[3]}%`,
          }}
        >
          {percentage[3].toFixed(0)}%
        </div>
      )}
    </div>
  );
}
